export default "__VITE_ASSET__CRUDfcKF__"